import { IntercomProvider as _IntercomProvider } from "react-use-intercom";
import { PropsWithChildren } from "react";
import { getIntercomAppId } from "@shared/analytics/utils";

const IntercomProvider = ({ children }: PropsWithChildren) => {
  const appId = getIntercomAppId(`${import.meta.env.VITE_APP_ENVIRONMENT}`);

  return (
    <_IntercomProvider appId={appId || ""} shouldInitialize={!!appId}>
      {children}
    </_IntercomProvider>
  );
};

export default IntercomProvider;
